window.addEventListener('load', function () {
    let swiper = new Swiper('.swiper', {
        // autoHeight: true,
        freeMode: true,
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: true,
        },
    });

    lightbox.option({
        'positionFromTop': 100
    });

    /* expand Contact on load */
    var contact = $(".contact");
    setTimeout(function () {
        if (contact.hasClass("closed")) {
            contact.removeClass("closed");
        }
        if ($("div.contact")) {
            /* get contact elements (left & right) */
            let l = $(".contact > .d-flex > .col-6")[0];
            let r = $(".contact > .d-flex > .col-6")[1];
            /* stop if no l & r are given / not found */
            if (l && r) {
                l.classList.add("left");
                r.classList.add("right");
                /* get sizes for comparison */
                var cHL = l.clientHeight,
                    cHR = r.clientHeight;
                /* get document width */
                var width = $(document).width();
                /* set left element height if width ok */
                if (cHR > cHL && width > 768) {
                    l.style.height = cHR + "px";
                }
            }
        }
    }, 100);

});
